import { useFormContext } from 'react-hook-form'

import { REFERRAL_LINK_REGEX } from '@tribeplatform/react-components/common/constants'
import { Form } from '@tribeplatform/react-components/Form'
import { T, useI18n } from '@tribeplatform/react-components/i18n'
import { useRouter } from '@tribeplatform/react-sdk'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { LoadingOverlay } from '@tribeplatform/react-ui-kit/LoadingOverlay'

import { RuntimeConfigs } from '../../../../../../../configs/runtime.js'

interface Props {
  disabled?: boolean
}

export const ReferralSettings = ({ disabled = false }: Props) => {
  const { $t } = useI18n()
  const { Link } = useRouter()
  const { watch } = useFormContext()

  const tribeBranding = watch('tribeBranding')
  const referralProgramEnabled = watch('referralProgramEnabled')

  return (
    <LoadingOverlay isLoading={disabled || !tribeBranding} opaque pulse={false}>
      <div className="flex flex-col space-y-5 pl-4">
        <Form.Toggle
          name="referralProgramEnabled"
          label={
            <span>
              <T
                defaultMessage="Earn with referrals"
                id="Admin.WhiteLabelSettings.EnableReferral"
              />{' '}
              <SvgIcon name="gift" inline />
            </span>
          }
          helperText={
            <T
              defaultMessage="Turn this on to replace the badge link with your own affiliate link and earn rewards. Must join the affiliate program first. Potential rewards up to {rewardAmount, number, ::sign-never currency/USD .}! <Link>Learn more</Link>"
              id="Admin.WhiteLabelSettings.EnableReferral.Description"
              values={{
                Link: ([value]) => (
                  <Link
                    href="https://bettermode.com/hub/referrals?utm_source=adminpanel&utm_campaign=whitelabelsetting"
                    variant="accent"
                  >
                    {value}
                  </Link>
                ),
                rewardAmount: 1000,
              }}
            />
          }
          disabled={disabled || !tribeBranding}
        />
        <Form.Input
          name="referralLink"
          type="url"
          placeholder="https://bettermode.cello.so/[your referral code]"
          label={
            <T
              defaultMessage="Your affiliate link"
              id="Admin.WhiteLabelSettings.ReferralLink"
            />
          }
          disabled={disabled || !referralProgramEnabled}
          validation={{
            required: referralProgramEnabled,
            pattern: {
              value: REFERRAL_LINK_REGEX,
              message: $t({
                defaultMessage: 'Invalid affiliate link',
                id: 'Admin.WhiteLabelSettings.ReferralLink.Invalid',
              }),
            },
          }}
          helperText={
            <T
              id="Admin.WhiteLabelSettings.ReferralLink.Description"
              defaultMessage="Copy and share your unique link to invite others and earn rewards.<br></br>Need your link? <Link>Join our affiliate program</Link> and paste it here to start earning."
              values={{
                Link: ([value]) => (
                  <Link
                    href={`${RuntimeConfigs.DASHBOARD_URL}/referral?utm_source=adminpanel&utm_campaign=whitelabelsetting`}
                    variant="accent"
                  >
                    {value}
                  </Link>
                ),
                br: () => <br />,
              }}
            />
          }
        />
      </div>
    </LoadingOverlay>
  )
}
